import { Box, Skeleton } from '@mui/material';

const EvaluationSkeleton = () => {
  return (
    <Box
      sx={{
        border: '1px solid #e5e7eb',
        borderRadius: '12px',
        p: 2,
        bgcolor: '#fafafa',
      }}
    >
      {/* Title row */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Skeleton variant="text" width="40%" height={28} />
        <Skeleton variant="circular" width={12} height={12} />
      </Box>

      {/* Lines */}
      <Skeleton variant="rounded" height={16} sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={16} sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={16} sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={16} sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={16} width="70%" />
    </Box>
  );
};

export default EvaluationSkeleton;
